/**
 * Global Constants for React Scroll Media
 */

// Scroll Logic
export const SCROLL_THRESHOLD = 0.0001; // Minimum progress change to trigger update
export const DEFAULT_SCROLL_LENGTH = '300vh';

// Memory Management
export const DEFAULT_LAZY_BUFFER = 10;
export const MAX_CACHE_SIZE = 50; // Fallback max size if not dynamic

// Sequences
export const DEFAULT_PAD_LENGTH = 0; // Default padding for image numbering

// Styles & Layout
export const DEFAULT_FALLBACK_COLOR = '#ccc';
